import React, {Suspense} from "react";
import {Switch} from "react-router-dom";
import {RegistrationDataPage} from "./pages/RegistrationDataPage";
import {ContentRoute, LayoutSplashScreen} from "../../../_metronic/layout";

export default function RegistrationDataListPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/registration-data" component={RegistrationDataPage}/>
      </Switch>
    </Suspense>
  );
}
